import { useDispatch } from 'react-redux';
import { selectPromotion } from 'store/campaign/campaignActions';

interface UseViewPromotionEventProps {
  promotion: {
    slot: string;
    name?: string;
    assetName?: string;
  };
}

export default function useSelectPromotionEvent({ promotion }: UseViewPromotionEventProps) {
  const dispatch = useDispatch();

  const fireSelectPromotionEvent = () => {
    if (!promotion.name) return;
    dispatch(
      selectPromotion({
        promotion,
      }),
    );
  };

  return { fireSelectPromotionEvent };
}
